/** Shared Mapbox / MapLibre configuration — aligned with Lezzet Yolda (Hupp) stack. */

export const MAPBOX_STREETS_STYLE = 'mapbox/streets-v12';

export const CARTO_VOYAGER_STYLE =
  'https://basemaps.cartocdn.com/gl/voyager-gl-style/style.json';

export const OSM_RASTER_TILES = 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';

export function getMapboxPublicToken(): string | undefined {
  const token = import.meta.env.VITE_MAPBOX_ACCESS_TOKEN?.trim();
  return token || undefined;
}

export function isMapboxConfigured(): boolean {
  const token = getMapboxPublicToken();
  return Boolean(token && token.startsWith('pk.'));
}

/** MapLibre GL style URL (vector). Falls back to Carto Voyager when token is missing. */
export function getMapStyleUrl(token?: string): string {
  const accessToken = token ?? getMapboxPublicToken();
  if (accessToken) {
    return `https://api.mapbox.com/styles/v1/${MAPBOX_STREETS_STYLE}?access_token=${accessToken}`;
  }
  return CARTO_VOYAGER_STYLE;
}

/** Raster tile template for Leaflet-style consumers (512px Mapbox tiles). */
export function getMapboxRasterTileUrl(token?: string): string {
  const accessToken = token ?? getMapboxPublicToken();
  if (!accessToken) {
    return OSM_RASTER_TILES;
  }
  return `https://api.mapbox.com/styles/v1/${MAPBOX_STREETS_STYLE}/tiles/256/{z}/{x}/{y}@2x?access_token=${accessToken}`;
}

/** Convert [lat, lng] (app convention) → MapLibre [lng, lat]. */
export function toLngLat([lat, lng]: [number, number]): [number, number] {
  return [lng, lat];
}

/** Convert [lng, lat] → [lat, lng]. */
export function toLatLng([lng, lat]: [number, number]): [number, number] {
  return [lat, lng];
}
